import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime free replacement',
  body: 'Break it and we replace it. Forever.',
  gold: true
}, {
  icon: LayersIcon,
  title: '3 lenses in every box',
  body: 'Clear, Amber and Smoke included.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'On every multi-pack order.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: '1 X1 system for $49.95',
    href: '/#offer'
  }, {
    label: 'Buy 2, get 1 free: $99.90',
    href: '/#offer'
  }, {
    label: 'Buy 4, get 2 free: $179.95',
    href: '/#offer'
  }, {
    label: 'Business / crew pack: $599.95',
    href: '/#offer'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Lifetime guarantee terms',
  to: '/legal/guarantee'
}, {
  label: 'Legal notice & safety',
  to: '/legal/legal-notice'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-811" data-mp="2m1mmy6rpeeoe">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-812" data-mp="2h42yyf57enj9">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-813" data-mp="2h4miu1eezlzx">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-814" data-mp="28592qpvsbz68">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-815" data-mp="1tdz692tk0871" />
                <span data-id="element-816" data-mp="1pau79a8omon5">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-817" data-mp="1ke3pmih8bkzm">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-818" data-mp="3w04i5ok70hck">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-819" data-mp="8vy0zzftwyuo">
        <div data-id="element-820" data-mp="38ce6hh6e1dow">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-821" data-mp="38cwd97qofab2">
            Grit<span className="text-grit-500" data-id="element-822" data-mp="3d81x810iqewi">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-823" data-mp="3hayk43x3cx69">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-824" data-mp="3m3rp8swh27iv">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-825" data-mp="2tmfddstowsga">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-826" data-mp="2k7day0iaigvt">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-827" data-mp="2k9q2949xu3lj">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-828" data-mp="2t7ieu0o9yx58">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvuegear.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-829" data-mp="336hfox2stoho">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-830" data-mp="18t00bxcjrxxq" />
              support@gritvuegear.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-831" data-mp="13vq15pzcw7wp">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-832" data-mp="3keifuv4mq1g2">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-833" data-mp="35otaenpi7b9z">
                U.S. fulfillment network
              </span>
              GritVue Gear ships from U.S. warehouses in Fort Worth, TX, Tampa, FL and Los Angeles, CA.
            </address>
            <div className="mt-4" data-id="element-834" data-mp="30t5kg6376e3f">
              <UspsBadge data-id="element-835" data-mp="2msb9pgsog11l" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-836" data-mp="2rqmj5qf289ja">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-837" data-mp="2rt8rvtdosv33">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-838" data-mp="q01ckjy2qdh7">
              {column.links.map(link => <li key={link.label} data-id="element-839" data-mp="oj5gw9ouzpv9">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-840" data-mp="ok7236zl9sqp">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-841" data-mp="1793uf5bfeb6a">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-842" data-mp="178ketv98zyvf">
          <nav aria-label="Legal" data-id="element-843" data-mp="xjal6ayra857">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-844" data-mp="xi8y184gtv74">
              {legal.map(item => <li key={item.label} data-id="element-845" data-mp="sj652m1rfffi">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-846" data-mp="si4t8fcx6owq">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-847" data-mp="1xk5om5oukorz">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-848" data-mp="1xjw06mjgapoe">Secure checkout</p>
            <div className="mt-2" data-id="element-849" data-mp="22gw3ipox1ebt">
              <PaymentLogos data-id="element-850" data-mp="27hadwedzp0d0" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-851" data-mp="27exnrdy2vjov">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-852" data-mp="2cfby52n5j5q2">
          <p className="text-xs text-steel-500" data-id="element-853" data-mp="2gfm0m5bqje06">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-854" data-mp="2q7s348zm5dtm">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-855" data-mp="305z77r8t01e7">Light where you look</p>
        </div>
      </div>
    </footer>;
}